module.exports = __webpack_public_path__ + "img/html.16e99d75.png";